export default __webpack_public_path__ + "static/media/children-icon.c6cf27d8.svg";